import { Role, Team } from '../../business/model/teamModel';
import { LangEnum } from '/@/enums/appEnum';
import { TeamStatusEnum } from '/@/enums/businessEnum';
import { planTypeEnum } from '/@/api/business/model/teamModel';

/**
 * @description: Login interface parameters
 */
export interface LoginParams {
  username: string;
  password: string;
  teamId?: string;
  isForceLogin?: boolean;
}
export interface LoginPhoneParams {
  username: string;
  password: string;
  code: string;
  phoneAreaCode: string;
  inviteCode?: string;
  isForceLogin?: boolean;
}
export enum loginErrorEnum {
  USER__USER__PASSWORD_NOT_CORRECT = 'USER__USER__PASSWORD_NOT_CORRECT',
  USER__USER__ONLINE = 'USER__USER__ONLINE',
  USER__USER__ACCOUNT_DISABLED = 'USER__USER__ACCOUNT_DISABLED',
  USER__USER__VERIFICATION_CODE_ERROR = 'USER__USER__VERIFICATION_CODE_ERROR',
}

export interface RoleInfo {
  roleName: string;
  value: string;
}

export interface User {
  id: number | string;
  username: string;
  password: string;
  email: string;
  nickname: string;
  intro: string;
  avatarUrl: string;
  avatarId?: number;
  hasPassword: boolean;
  phone: string;
  language: LangEnum;
  lastLoginTime?: any;
  createdAt?: string;
}

/** Team */
export interface ILoggedTeam {
  id: number | string;
  name: string;
  planId: number;
  planType: planTypeEnum;
  timeZone: string;
  timeZoneOffset: string;
  planChangeType: planChangeTypeEnum;
  isConfirmedPlanChange: boolean;
  isDefaultTeam: boolean;
  isDemoTeam: boolean;
  isDeleted: boolean;
  createdBy: number;
  updatedBy?: Undefinedable<number>;
  createdAt: string;
  updatedAt?: string;
  inviteCode: string;
  status: TeamStatusEnum;
  expireAt?: string;
  isExistActiveSubscription: boolean;
}
export enum planChangeTypeEnum {
  PRICE_UP = 'PRICE_UP',
  PRICE_DOWN = 'PRICE_DOWN',
  PLAN_DISABLED = 'PLAN_DISABLED',
}

/**
 * @description: Login interface return value
 */
export interface LoginResultModel {
  token: string;
  user: User;
  team: Team;
}

/**
 * @description: Get user information return value
 */
export interface GetUserInfoModel {
  user: User;
  team: Undefinedable<ILoggedTeam>;
  roles: Role[];
}

export interface GetUserInfoTeamModel {
  user: User;
  teams: Undefinedable<Team[]>;
}

export enum AppMode {
  China = 'cloud-china',
  Global = 'cloud-global',
}

export interface ConfigModal {
  uba?: {
    mixpanel: {
      enabled: boolean;
      token: string;
    };
  };
  business?: {
    weChatQrCode: string;
    phone: string;
  };
  isShowAiMaid?: boolean;
  runningMode: AppMode;
  hideLogo?: boolean;
  userAuth?: {
    email: {
      enabled: boolean;
    };
    phone: {
      enabled: boolean;
    };
  };
  description?: string;
  enterpriseName?: string;
  logoUrl?: string;
  licenseEndAt?: string;
  licenseStatus?: 'EXPIRED' | 'ACTIVE';
  taskBatchCreateMaximum?: number;
  publicDemoTeamEnabled?: boolean;
  expirationReminderDays: number;
}

export interface SignUpParams {
  email: string;
  nickname: string;
  password: string;
  // teamId?: number;
  token: string;
  teamCode?: string | undefined;
}

export interface LoginConfirmParams {
  email: string;
}

export interface IVerificationCode {
  sessionId: string;
  sig: string;
  token: string;
  scenes: string;
  phoneNumber: string;
}

/** Home */
export interface IEventStatisticProps {}
export type IEventStatistic = {
  [property in EventNameEnum]?: boolean;
} & IEventStatisticProps;

export interface IMarkEventDone {
  eventName: EventNameEnum;
}
export enum EventNameEnum {
  isDatasetViewed = 'isDatasetViewed',
  isOntologyViewed = 'isOntologyViewed',
  isToDoViewed = 'isToDoViewed',
  isTaskManagementViewed = 'isTaskManagementViewed',
  isDatasetCreated = 'isDatasetCreated',
  isUploadPopoverShowed = 'isUploadPopoverShowed',
  isOntologyCreated = 'isOntologyCreated',
  isTaskCreated = 'isTaskCreated',
}
